import React, { useState } from "react";
import { object } from "prop-types";
import { Helmet } from "react-helmet";

const DNQMain = ({ siteData, layoutType }) => {
  const siteDataValue = siteData.content_manage_sites.find((item) => item.page_id === (layoutType === "3" || layoutType === 3 ? 1 : 9));

  return (
    <>
      <div className="pageTitle" style={{ backgroundColor: siteData.primary_color }}>
        <Helmet>
          <title>{siteDataValue.meta_title}</title>
          <meta name="description" content={siteDataValue.meta_description} />
          <link rel="icon" href={siteData.favicon} sizes="16x16" />
        </Helmet>
        <div className="container">
          <div className="row">
            <div className="col-sm-12">
              <h1>{siteDataValue.page_title}</h1>
              <p>{siteDataValue.page_sub_title}</p>
            </div>
          </div>
        </div>
      </div>

      <section className="innerPageContent">
        <div className="container">
          <div className="row">
            {siteDataValue.content ? (
              <div className="col-md-4">
                <div className="form-heading">
                  <div className="MapLocation"></div>
                </div>
                <div
                  dangerouslySetInnerHTML={{
                    __html: siteDataValue.content,
                  }}
                ></div>
              </div>
            ) : (
              <></>
            )}
          </div>
        </div>
      </section>
    </>
  );
};

DNQMain.propTypes = {
  siteData: object.isRequired,
  layoutType: object,
};

DNQMain.defaultProps = {
  layoutType: "3",
};

export default DNQMain;
